import { render, staticRenderFns } from "./DmqCartItem.vue?vue&type=template&id=5b5ea484&"
import script from "./DmqCartItem.vue?vue&type=script&lang=ts&"
export * from "./DmqCartItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports